import type { PublicMembersFilters, PublicMembersListPayload, PublicMembersSuggestion } from './types';

function restUrl(restBaseUrl: string, path: string): string {
    const base = String(restBaseUrl || '/wp-json/gas/v1').replace(/\/+$/, '');
    return new URL(`${base}${path}`, window.location.origin).toString();
}

async function parseEnvelope<T>(response: Response): Promise<T> {
    const json = await response.json();
    if (!response.ok) {
        throw new Error(json?.message || `HTTP ${response.status}`);
    }
    return (json?.data ?? json) as T;
}

export async function fetchPublicMembers(
    restBaseUrl: string,
    restNonce: string | undefined,
    filters: PublicMembersFilters,
): Promise<PublicMembersListPayload> {
    const response = await fetch(restUrl(restBaseUrl, '/member-directory/list'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...(restNonce ? { 'X-WP-Nonce': restNonce } : {}),
        },
        body: JSON.stringify({
            ...filters,
            start: 0,
            length: -1,
        }),
    });

    return parseEnvelope<PublicMembersListPayload>(response);
}

export async function fetchPublicMembersSuggestions(
    restBaseUrl: string,
    restNonce: string | undefined,
    term: string,
): Promise<PublicMembersSuggestion[]> {
    const url = new URL(restUrl(restBaseUrl, '/member-directory/autocomplete'));
    url.searchParams.set('term', term);

    const response = await fetch(url.toString(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            ...(restNonce ? { 'X-WP-Nonce': restNonce } : {}),
        },
    });

    return parseEnvelope<PublicMembersSuggestion[]>(response);
}
